import React from 'react'

export default function NotFound() {
  return (
    <div className='bg-red-500 flex flex-row justify-center items-center min-h-screen text-6xl'><p className='text-white'>404 - Page Not Found</p></div>
  )
}
